import React from 'react';
import styled from 'styled-components';

const View = styled.div`
    @media (min-width: 40em) {
        margin-top: 35px;
        display: flex;
        align-items: center;
    }
`;

const List = styled.ul`
    margin: 0;
    margin-left: -20px;
    padding: 0;
    list-style: none;
    text-align: center;

    @media (min-width: 40em) {
        width: 130px;
        order: -1;
    }

    img {
        width: 75px;
    }
`;

const ListItem = styled.li`
    margin-left: 20px;
    margin-bottom: 20px;
    padding: 5px;
    border: 1px solid #333;
    display: inline-block;
    cursor: pointer;
    border-width: ${props => (props.selected ? '1px' : '0')};
`;

const Main = styled.div`
    padding-bottom: 15px;

    @media (min-width: 40em) {
        padding-bottom: 0;
        padding-left: 35px;
    }

    img {
        max-width: 100%;
    }
`;

class GalleryApp extends React.Component {
    state = {
        selectedIndex: 0,
    };

    render() {
        const { items } = this.props;
        const { selectedIndex } = this.state;

        return (
            <View>
                <Main>
                    <img src={items[selectedIndex].large} alt="" />
                </Main>

                <List>
                    {items.map((item, index) => {
                        return (
                            <ListItem
                                key={item.small}
                                selected={index === selectedIndex}
                                onClick={() =>
                                    this.setState({
                                        selectedIndex: index,
                                    })
                                }
                            >
                                <img src={item.small} alt="" />
                            </ListItem>
                        );
                    })}
                </List>
            </View>
        );
    }
}

export default GalleryApp;



// WEBPACK FOOTER //
// ./src/components/GalleryApp.js